export interface TrainLayoutInput {
  worldWidth: number;
  locomotiveWidth: number;
  wagonGap: number;
  wagonWidths: number[];
  activeWagonCenterX: number;
  completedCount: number;
}

export interface WagonLayout {
  questionIndex: number;
  width: number;
  baseCenterX: number;
  centerX: number;
  left: number;
  right: number;
}

export interface TrainLayout {
  totalWidth: number;
  startX: number;
  forwardOffset: number;
  locomotiveBaseCenterX: number;
  locomotiveCenterX: number;
  wagons: WagonLayout[];
}

export function calculateTrainLayout(input: TrainLayoutInput): TrainLayout {
  const wagonCount = input.wagonWidths.length;
  const totalWagonWidth = input.wagonWidths.reduce((total, width) => total + width, 0);
  const totalWidth = totalWagonWidth + wagonCount * input.wagonGap + input.locomotiveWidth;
  const startX = (input.worldWidth - totalWidth) / 2;
  const getBaseCenterX = (questionIndex: number) => {
    const widthsToLeft = input.wagonWidths
      .slice(questionIndex + 1)
      .reduce((total, width) => total + width + input.wagonGap, 0);
    return startX + widthsToLeft + input.wagonWidths[questionIndex] / 2;
  };
  const activeBaseCenterX = getBaseCenterX(input.completedCount);
  const forwardOffset = input.activeWagonCenterX - activeBaseCenterX;

  const wagons = input.wagonWidths.map((width, questionIndex) => {
    const baseCenterX = getBaseCenterX(questionIndex);
    const centerX = baseCenterX + forwardOffset;
    return {
      questionIndex,
      width,
      baseCenterX,
      centerX,
      left: centerX - width / 2,
      right: centerX + width / 2,
    };
  });

  const locomotiveBaseCenterX = startX + totalWagonWidth + wagonCount * input.wagonGap + input.locomotiveWidth / 2;
  return {
    totalWidth,
    startX,
    forwardOffset,
    locomotiveBaseCenterX,
    locomotiveCenterX: locomotiveBaseCenterX + forwardOffset,
    wagons,
  };
}
